<template>
  <div style="padding-top:-2px;margin-top:-2px;">
    <template v-if="check == false && radio == false && checkList == false && multiple == false">
      <s-select-generic autocomplete itemtext="GenDescription" itemvalue="GenID" id="GenDescription" :value="value"
        @input="input($event)" :config="config" :label="label" :return-object=returnObject placeholder="Selecciona área"
        :full="full" :text="text" :clearable=clearable :disabled="disabled" :noDefault="true"
        @updateData="onGenericDataLoaded">
      </s-select-generic>
    </template>


    <div v-if="checkList || multiple">
      <v-select multiple v-model="selected" :items="items" item-text="GenDescription" item-value="GenID"
        :return-object="returnObject" :label="label" :clearable="clearable" :disabled="disabled" :readonly="readonly"
        hide-details @input="input($event)">
        <template v-slot:selection="{ item, index }">
          <v-chip v-if="index < 1" x-small class="" color="teal" label outlined>
            <span class="text-truncate d-inline-block" style="max-width: 120px;">
              {{ item.GenDescription }}
            </span>
          </v-chip>
          <span v-else-if="index === 1" class="grey--text text--darken-1">
            +{{ selected.length - 1 }}
          </span>
        </template>
      </v-select>
    </div>
  </div>
</template>

<script>
import _sGenericService from "./../../services/General/GenericService";
export default {
  name: "",
  components: {},
  props: {
    clearable: {
      type: Boolean,
      default: false,
    },
    cceID: {
      type: Number,
      default: 0,
    },
    onlyAccountCapex: {
      type: Number,
      default: 0,
    },
    noDefault: {
      type: Boolean,
      default: false,
    },
    value: null,
    text: { type: String, default: "" },
    label: {
      type: String,
      default: "Linea de Negocio",
    },
    returnObject: {
      type: Boolean,
      default: false,
    },
    centercost: {
      type: Boolean,
      default: false,
    },
    full: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    check: {
      type: Boolean,
      default: false,
    },
    radio: {
      type: Boolean,
      default: false,
    },
    checkList: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    allline: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    effectiveAllLine() {
      if (this.allline === 1 || this.allline === "1") return 1;
      if (this.$fun && typeof this.$fun.hasSpecialPermission === "function" && this.$fun.hasSpecialPermission("AllLine")) {
        return 1;
      }
      return 0;
    },
  },
  watch: {
    value(value) {
      this.item = value;
    },
    cceID() {
      this.resetToCurrentCenterCost();

      if (this.checkList || this.multiple) {
        this.loadData();
      }
    },
    // 🔧 WATCHER MEJORADO PARA SELECTED
    selected: {
      handler(newValue) {
        if (this.multiple || this.checkList || this.check) {
          this.emitMultipleValue(newValue);
        } else {
          let foundItem = this.items.find((x) => x[this.id] == newValue);
          if (!this.returnObject) {
            this.$emit("input", newValue);
          } else {
            this.$emit("input", foundItem);
          }
        }
      },
      deep: true,
      immediate: false,
    },
  },
  methods: {
    input(val) {
      this.$emit("input", val);
    },

    hasCurrentValue() {
      if (this.returnObject) {
        return !!(this.value && this.value.GenID);
      }

      return this.value !== null && this.value !== undefined && this.value !== "";
    },

    emitSingleAutoSelection(items) {
      if (this.check || this.radio || this.checkList || this.multiple) {
        return;
      }

      if (!Array.isArray(items) || items.length !== 1) {
        return;
      }

      if (this.hasCurrentValue()) {
        return;
      }

      const selectedItem = items[0];
      const selectedValue = this.returnObject ? selectedItem : selectedItem?.GenID;
      this.$emit("input", selectedValue);
    },

    resetToCurrentCenterCost() {
      this.isFallbackAllLines = false;
      this.config = {
        ...this.config,
        params: {
          ...this.config.params,
          CceID: this.cceID || 0,
          AllLine: this.effectiveAllLine,
          OnlyAccountCapex: this.onlyAccountCapex,
        },
      };
    },

    onGenericDataLoaded(items) {
      const normalizedItems = Array.isArray(items) ? items : [];

      if (!this.isFallbackAllLines && normalizedItems.length === 0 && (this.cceID || 0) > 0) {
        this.isFallbackAllLines = true;
        this.config = {
          ...this.config,
          params: {
            ...this.config.params,
            CceID: 0,
            AllLine: 1,
            OnlyAccountCapex: this.onlyAccountCapex,
          },
        };
        return;
      }

      this.emitSingleAutoSelection(normalizedItems);
    },

    emitMultipleValue(value) {
      if (!this.returnObject) {
        const strObj = JSON.stringify(value);
        this.$emit("input", strObj);
      } else {
        const objValues = value.map((val) => this.items.find((x) => x[this.id] === val)).filter(Boolean);
        this.$emit("input", objValues);
      }
    },

    loadData() {
      this.$http.post(this.config.url, {}, { params: this.config.params }).then((r) => {
        if (r.status == 200) {
          const normalizedItems = Array.isArray(r.data) ? r.data : [];

          if (!this.isFallbackAllLines && normalizedItems.length === 0 && (this.cceID || 0) > 0) {
            this.isFallbackAllLines = true;
            this.config.params.CceID = 0;
            this.config.params.AllLine = 1;
            this.config.params.OnlyAccountCapex = this.onlyAccountCapex;
            this.loadData();
            return;
          }

          this.items = normalizedItems;
          this.emitSingleAutoSelection(this.items);
        }
      });
    }

  },
  data: () => ({
    item: 0,
    selected: [],
    val: '',
    items: [],
    config: {},
    isFallbackAllLines: false,
  }),

  created() {
    this.config = {
      url: _sGenericService.getUrlSearchBusinessLine(),
      title: this.label,
      params: { search: '', CceID: this.cceID, requestID: this.$fun.getUserID(), AllLine: this.effectiveAllLine, OnlyAccountCapex: this.onlyAccountCapex }
    }
  }

}

</script>
